import {
    MassProductDetailsTypes
} from "./MassProductDetails.types";
import styles from "./MassProductDetails.module.scss";
import React from "react";
import {Icon} from "@renta-apps/athenaeum-react-components";
import {ReturnInspectionStatus} from "@/models/Enums";
import Localizer from "@/localization/Localizer";
import RentaToolsConstants from "@/helpers/RentaToolsConstants";
import {FeatureSwitch} from "@/providers/FeatureSwitch";

const MassProductDetails = ({ details, returnInspectionStatus } : MassProductDetailsTypes) => {
    const getStatusName = (): string => {
        switch (returnInspectionStatus) {
            case ReturnInspectionStatus.Completed:
                return Localizer.returnInspectionCompleted;
            case ReturnInspectionStatus.InProgress:
                return Localizer.returnInspectionInProgress;
            case ReturnInspectionStatus.NotCompleted:
                return Localizer.returnInspectionNotCompleted;
            case ReturnInspectionStatus.PartlyCompleted:
                return Localizer.returnInspectionPartlyCompleted;
            case ReturnInspectionStatus.Waiting:
            default:
                return Localizer.returnInspectionWaitingForReturnInspection;
        }
    };
    
    return (
        <div className={styles.massProductDetailsContainer}>
            <span className={styles.statusText}>{getStatusName()}</span>
            <div className={styles.massProductDetailsRow}>
                <Icon name={"fal fa-exchange"} className={styles.icon} />
                <Icon name={"fas fa-heart-broken"} className={styles.icon}/>
                <FeatureSwitch flagName={RentaToolsConstants.featureFlagMassProductInvoicing}>
                    <Icon name={"fal file-invoice"} className={styles.icon}/>
                </FeatureSwitch>
            </div>
            {
                
            details.map((detail, index) => (
                <div key={`${detail.massProductId}-${index}`} className={styles.massProductRow}>
                    <div className={styles.massProductDetailsInfo}>
                        <span className={styles.productId}>
                            {detail.massProductId}
                        </span>
                        <span>
                            {detail.massProductName}
                        </span>
                    </div>
                    <div className={styles.massProductDetailsRow}>
                        <div className={styles.iconContainer}>
                            <span> {detail.returnedDevicesCount} </span>
                        </div>
                        <div className={styles.iconContainer}>
                            <span> {detail.needRepairDevicesCount} </span>
                        </div>
                        <FeatureSwitch flagName={RentaToolsConstants.featureFlagMassProductInvoicing}>
                            <div className={styles.iconContainer}>
                                <span> {detail.inspectedDevicesCount} </span>
                            </div>
                        </FeatureSwitch>    
                    </div>
                </div>
            ))}
        </div>
    )
}


export default MassProductDetails;